export default __webpack_public_path__ + "static/media/two_user.d0c43901.svg";